
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const PartnershipLevelsSection = () => {
  const partnershipLevels = [
    {
      title: "Integration Partner",
      description: "Technology integration and API access",
      features: ["API documentation and support", "Technical integration assistance", "Joint testing and validation", "Basic co-marketing opportunities"],
      ideal: "Technology companies with complementary solutions"
    },
    {
      title: "Channel Partner", 
      description: "Reseller and referral partnerships",
      features: ["Sales training and materials", "Lead sharing programs", "Revenue sharing opportunities", "Marketing support and resources"],
      ideal: "Service providers wanting to offer SeniorThrive to clients"
    },
    {
      title: "Strategic Partner",
      description: "Deep collaboration and co-development", 
      features: ["Custom feature development", "White-label solutions", "Joint go-to-market strategy", "Dedicated account management"],
      ideal: "Large organizations with significant senior populations"
    }
  ];

  return (
    <section className="py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Partnership Levels</h2>
            <p className="text-xl text-muted-foreground">
              From simple integrations to strategic alliances - find the right partnership level for your organization
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {partnershipLevels.map((level, index) => (
              <div key={index} className="glass-card p-8 rounded-md hover-scale">
                <h3 className="text-2xl font-bold mb-3">{level.title}</h3>
                <p className="text-muted-foreground mb-6">{level.description}</p>
                
                <div className="space-y-3 mb-6">
                  <h4 className="font-bold text-sm uppercase tracking-wide">Includes:</h4>
                  <ul className="space-y-2">
                    {level.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start gap-2">
                        <CheckCircleIcon className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                        <span className="text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="p-4 bg-accent/50 rounded-xl">
                  <p className="text-sm font-medium text-muted-foreground">
                    <strong>Ideal for:</strong> {level.ideal}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipLevelsSection;
